import { FC } from "react";
import { Datagrid, List, TextField } from "react-admin";

import CustomPagination from "../../../components/CustomPagination";
import EmptyDataText from "../../../components/EmptyDataText";
import TimestampField from "../../../components/TimestampField";
import CancelSubscription from "./components/CancelSubscription";
import PackageDays from "./components/PackageDays";
import PackageFees from "./components/PackageFees";
import PackageName from "./components/PackageName";
import SubscribedStatusText from "./components/SubscribedStatus";
import ClientEmail from "../../../components/ClientData/components/ClientEmail";
import ClientName from "../../../components/ClientData/components/ClientName";
import ClientPhoneNumber from "../../../components/ClientData/components/ClientPhoneNumber";

const GymMembersList: FC<any> = (props) => {
  return (
    <List
      {...props}
      sort={{ field: "createdAt", order: "desc" }}
      pagination={<CustomPagination />}
      exporter={false}
      bulkActionButtons={false}
    >
      <Datagrid empty={<EmptyDataText message="No members yet!" />}>
        <ClientName label="Client" />
        <ClientPhoneNumber label="Phone " />
        <ClientEmail label="Email" />
        <PackageName label="Package Name" />
        <PackageFees label="Package Fees" />
        <PackageDays label="Package Days" />
        <SubscribedStatusText label="Status" />
        <TextField source="paymentMethod" />

        <TimestampField source="expiryDate" label="Expiry Date" sortable={false} />
        <TimestampField source="createdAt" label="Created At" />

        <CancelSubscription />
      </Datagrid>
    </List>
  );
};

export default GymMembersList;
